import React from "react";
import { Link } from "react-router-dom";
import { Calendar as CalendarIcon, ArrowRight } from "lucide-react";
import MarketingLayout, { useMLang } from "./MarketingLayout";

const BLOG = {
    en: {
        title: "Stories from the kitchen",
        sub: "Tips, tactics and small wins from Latin restaurants growing online.",
        posts: [
            {
                slug: "whatsapp-vs-checkout",
                date: "May 14, 2026",
                category: "Strategy",
                title: "Why WhatsApp beats checkout pages for 80% of Latin restaurants",
                excerpt: "Card processing eats 2.9% + $0.30 of every order. For a $12 plate of mangú that's almost 5%. WhatsApp + manual P2P costs 0%. Here's the math.",
            },
            {
                slug: "ai-food-photos-100-dollars",
                date: "May 10, 2026",
                category: "AI",
                title: "We replaced a $100/hour food photographer with Gemini Nano Banana",
                excerpt: "Five plate photos for $0.05 of API credit. Real before/after comparisons inside, plus the exact prompts our Pro tier uses.",
            },
            {
                slug: "catering-calendar-broadcast",
                date: "Apr 28, 2026",
                category: "Operations",
                title: "How Delicias does a Saturday catering broadcast in 30 seconds",
                excerpt: "Pickup-day reminders, prep-list aggregation, one-click WhatsApp blast. The exact playbook our flagship customer uses every Friday.",
            },
        ],
        readMore: "Read more →",
        comingSoon: "Article preview coming soon",
    },
    es: {
        title: "Historias desde la cocina",
        sub: "Consejos, tácticas y pequeñas victorias de restaurantes latinos creciendo en línea.",
        posts: [
            {
                slug: "whatsapp-vs-checkout",
                date: "14 mayo 2026",
                category: "Estrategia",
                title: "Por qué WhatsApp le gana al checkout para el 80% de los restaurantes latinos",
                excerpt: "Procesar tarjetas se come 2.9% + $0.30 por pedido. Para un plato de mangú de $12 eso es casi 5%. WhatsApp + pago manual cuesta 0%. Aquí está la matemática.",
            },
            {
                slug: "ai-food-photos-100-dollars",
                date: "10 mayo 2026",
                category: "IA",
                title: "Reemplazamos a un fotógrafo gastronómico de $100/hora con Gemini Nano Banana",
                excerpt: "Cinco fotos de platos por $0.05 de créditos API. Comparativas antes/después y los prompts exactos que usamos en Pro.",
            },
            {
                slug: "catering-calendar-broadcast",
                date: "28 abr 2026",
                category: "Operaciones",
                title: "Cómo Delicias hace un envío de catering sabatino en 30 segundos",
                excerpt: "Recordatorios del día, agregación de prep, un click para WhatsApp masivo. El playbook que nuestro cliente insignia usa cada viernes.",
            },
        ],
        readMore: "Leer más →",
        comingSoon: "Vista previa del artículo próximamente",
    },
};

const MarketingBlog = () => {
    const { lang } = useMLang();
    const c = BLOG[lang];
    return (
        <MarketingLayout testid="marketing-blog">
            <section className="max-w-5xl mx-auto px-6 sm:px-10 pt-16 sm:pt-24 pb-10">
                <h1 className="font-serif font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">{c.title}</h1>
                <p className="text-lg text-white/65 mt-5 max-w-2xl">{c.sub}</p>
            </section>

            <section className="max-w-5xl mx-auto px-6 sm:px-10 pb-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {c.posts.map((p, i) => (
                    <article
                        key={p.slug}
                        data-testid={`blog-post-${p.slug}`}
                        className="group p-6 rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] transition-colors"
                    >
                        <div className="flex items-center gap-3 text-[11px] uppercase tracking-wider text-white/50 mb-3">
                            <span className="text-orange-300">{p.category}</span>
                            <span className="inline-flex items-center gap-1"><CalendarIcon className="w-3 h-3" /> {p.date}</span>
                        </div>
                        <h2 className="font-serif font-bold text-xl leading-snug mb-3 group-hover:text-orange-200">{p.title}</h2>
                        <p className="text-sm text-white/60 leading-relaxed">{p.excerpt}</p>
                        <button
                            disabled
                            title={c.comingSoon}
                            className="mt-5 text-xs text-orange-300/60 inline-flex items-center gap-1 cursor-not-allowed"
                        >
                            {c.readMore}
                        </button>
                    </article>
                ))}
            </section>

            <section className="max-w-3xl mx-auto px-6 sm:px-10 pb-24 text-center">
                <Link to="/heavenly/pricing" className="inline-flex items-center gap-2 text-orange-300 hover:text-orange-200 font-semibold">
                    {lang === "es" ? "Ver precios" : "See pricing"}
                    <ArrowRight className="w-4 h-4" />
                </Link>
            </section>
        </MarketingLayout>
    );
};

export default MarketingBlog;
